module.exports = __webpack_public_path__ + "static/images/4_snowy_day.87a74ca2.jpg";